import { ACCESSIBILITY_OPTIONS_KEYS } from './accessibilityUtils'

export function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item)
}

// export function mergeConfig(target={}, source={}) {
//   let output = Object.assign({}, target);
//   if (isObject(target) && isObject(source)) {
//     Object.keys(source).forEach(key => {
//       if (isObject(source[key])) {
//         if (!(key in target)){
//           Object.assign(output, { [key]: source[key] });
//         } else {
//           output[key] = mergeConfig(target[key], source[key]);
//         }
//       } else {
//         if(isObject(target[key]) && target[key].default!==undefined) {
//           Object.assign(output, { [key]: mergeConfig(target[key], {value: source[key]}) })
//         }
//         else {
//           Object.assign(output, { [key]: source[key] });
//         }
//       }
//     });
//   }
//   return output;
// }

// NADA CLARO ESTE ULTIMO CAMBIO, volver a la version de arriba si hace falta...
export function mergeConfig(target = {}, source = {}) {
  let output
  if (isObject(target) && isObject(source)) {
    output = Object.assign({}, target)
    Object.keys(source).forEach((key, i) => {
      if (key === 'index') return
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, { [key]: source[key] })
        } else {
          output[key] = mergeConfig(target[key], source[key])
        }
      } else {
        if (isObject(target[key]) && target[key].default !== undefined) {
          Object.assign(output, { [key]: mergeConfig(target[key], { value: source[key] }) })
        }
        // DANGER: este "else if" era "else" pero se cargaba las "options" (del colorScale p.ej)
        // DOUBLE DANGER: estaba mirando !output[key] pero cosas como "" daban false cambio a ==null or undefined
        else if (output[key] === null || output[key] === undefined) {
          Object.assign(output, { [key]: source[key] })
        }
      }

      if (isObject(output[key])) {
        output[key].index =
          target[key] && target[key].index !== undefined
            ? target[key].index
            : source[key].index !== undefined
            ? source[key].index
            : i
      }
    })
  } else {
    output = Object.assign({}, source)
    output.value = target
  }

  output.exposed = source.exposed
  if (target && target.exposed !== undefined) {
    // console.log("target.exposed",target,target.exposed)
    output.exposed = target.exposed
  }

  return output
}
function stringifyConfig(config) {
  return JSON.stringify(
    {
      ...config,
      type: config.type
        ? (Array.isArray(config.type) ? config.type : [config.type]).map(t => t.name)
        : 'No types found! (probably wrong key)',
    },
    null,
    2
  )
}
export function extractValues(target) {
  let values = Object.keys(target).reduce((out, k) => {
    if (k === 'exposed' || k === 'index') return out
    let ob = target[k]
    let val = ob.value !== undefined ? ob.value : ob.default
    if (isObject(ob)) {
      if (val === undefined) out[k] = extractValues(ob)
      // else out[k] = val
      else {
        if (validateOption(ob)) {
          out[k] = val
        } else {
          console.error(
            `configUtils:extractValues: WRONG TYPE excluded (using default):\nkey: ${k},\nvalue: ${val},\ndefinition: ${stringifyConfig(
              ob
            )}`
          )
          out[k] = ob.default
        }
      }
    } else {
      // console.error("Esto no tendria que poder pasar nunca, no!?")
      console.error(
        `configUtils:extractValues: WRONG CONFIG:\nkey: ${k},\nvalue: ${val},\ndefinition: ${stringifyConfig(
          ob
        )}`
      )
      // console.log(`Option ${k} doesnt belong to this "level"`)
      // out[k] = ob
    }
    return out
  }, {})
  return values
}
export function setDefaultValues(target) {
  let values = Object.keys(target).reduce((out, k) => {
    if (k === 'exposed') return out
    let ob = target[k]
    let val = ob.value !== undefined ? ob.value : ob.default

    if (val === undefined) out[k] = setDefaultValues(ob)
    // else out[k] = val
    else {
      if (validateOption(ob)) {
        ob.value = ob.value !== undefined ? ob.value : ob.default
        out[k] = ob
      } else {
        console.error(
          `configUtils:setDefaultValues: WRONG TYPE excluded:\nkey: ${k},\nvalue: ${val},\ndefinition: ${stringifyConfig(
            ob
          )}`
        )
      }
    }

    return out
  }, {})
  return values
}

export function filterNonDefaults(values, defaults) {
  let result = Object.keys(values).reduce((out, k) => {
    let val = values[k]
    let def = defaults[k]
    if (isObject(val) && def && def.default === undefined) {
      let child = filterNonDefaults(val, def)
      if (Object.keys(child).length > 0) out[k] = child
    } else {
      if (!def)
        console.error(
          `configUtils:filterNonDefaults: WRONG CONFIG (probably wrong key):\nkey:${k}\nval:${val}\ndef:${def}`
        )
      else if (JSON.stringify(val) !== JSON.stringify(def.value || def.default)) {
        out[k] = { value: val }
      }
    }
    return out
  }, {})
  return result
}

function isOfType(val, t) {
  // val = t(val) || val //No me gusta mucho... Es para "convertir" los "400" en 400
  // return (val===null && t===null) || (val instanceof t || typeof val === t.name.toLowerCase())
  return (
    (val === null && t === null) ||
    (val !== null && t !== null && (val instanceof t || typeof val === t.name.toLowerCase()))
  )
}
function validateOption(opt) {
  if (opt.type) {
    let val = opt.value !== undefined ? opt.value : opt.default
    let types = Array.isArray(opt.type) ? opt.type : [opt.type]
    let validType = types.reduce((res, t) => res || isOfType(val, t), false)
    let validValue = true
    if (opt.options && isOfType(val, String)) validValue = opt.options.indexOf(val) >= 0
    return validType && validValue
  } else return false
}
// export function validateConfig(config){
//   Object.keys(config).forEach((k)=>{
//     let ob = config[k]
//     if(!ob){
//       console.log("ob undefined?!",ob,k)
//     }
//     else if(ob.type) {
//       let typeMatch = ob.default instanceof ob.type || typeof ob.default === ob.type.name.toLowerCase()
//       console.log("TyepMatch:",k,ob.default,ob.type,typeMatch)
//     }
//     else if(typeof ob === 'object' && Object.keys(ob).length>0) {
//       validateConfig(ob)
//     }
//   })
// }

export function flattenConfig(config, namespace = 'component') {
  let arr = Object.keys(config).reduce((arr, k) => {
    let ob = config[k]
    if (ob && k !== 'index') {
      let idx = config.index ? [config.index].flat() : []
      idx.push(ob.index)
      if (ob && ob.type) {
        arr = arr.concat([{ key: `${namespace}.${k}`, value: ob, index: idx }])
      } else if (ob && typeof ob === 'object' && Object.keys(ob).length > 0) {
        arr = arr.concat([flattenConfig({ ...ob, index: idx }, `${namespace}.${k}`)])
      }
    }
    return arr
  }, [])
  return arr.flat()
}

export function unflattenConfig(configArray) {
  let out = configArray.reduce((ob, row) => {
    let parts = row.key.split('.')
    let last = parts.pop()
    let pointer = parts.reduce((subob, part) => {
      if (!subob[part]) subob[part] = {}
      return subob[part]
    }, ob)
    pointer[last] = row.value
    return ob
  }, {})
  return out
}

export function setConfigValue(config, path, value) {
  let parts = path.split('.')
  let curr = config
  parts.forEach((key, i) => {
    if (i === parts.length - 1) {
      curr[key] = { ...(curr[key] || {}), value }
    } else {
      if (!curr[key]) curr[key] = {}
      curr = curr[key]
    }
  })
}

export function isDarkMode(config, accessibilityOptions) {
  return accessibilityOptions
    ? accessibilityOptions[ACCESSIBILITY_OPTIONS_KEYS.darkMode]
    : config.skin === 'dark'
}
